import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "formContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_bra_config = _resolveComponent("bra-config")!
  const _component_bottom_underwear_config = _resolveComponent("bottom-underwear-config")!
  const _component_lingerie_config = _resolveComponent("lingerie-config")!
  const _component_pajamas_config = _resolveComponent("pajamas-config")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "SQM Combination Config",
        text: "SQM Combination Config",
        class: "mb-0"
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: _normalizeClass(["btn me-2", _ctx.activeSection == 'BRA' ? 'btn-tertiary' : 'btn-secondary']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeSection = 'BRA'))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "BRA",
            text: "BRA"
          })
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["btn me-2", _ctx.activeSection == 'BOTTOM UNDERWEAR' ? 'btn-tertiary' : 'btn-secondary']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeSection = 'BOTTOM UNDERWEAR'))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "BOTTOM UNDERWEAR",
            text: "BOTTOM UNDERWEAR"
          })
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["btn", _ctx.activeSection == 'LINGERIE' ? 'btn-tertiary' : 'btn-secondary']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeSection = 'LINGERIE'))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "LINGERIE",
            text: "LINGERIE"
          })
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["btn", _ctx.activeSection == 'PAJAMAS' ? 'btn-tertiary' : 'btn-secondary']),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeSection = 'PAJAMAS'))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "PAJAMAS",
            text: "PAJAMAS"
          })
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.activeSection == 'BRA')
        ? (_openBlock(), _createBlock(_component_bra_config, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.activeSection == 'BOTTOM UNDERWEAR')
        ? (_openBlock(), _createBlock(_component_bottom_underwear_config, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.activeSection == 'LINGERIE')
        ? (_openBlock(), _createBlock(_component_lingerie_config, { key: 2 }))
        : _createCommentVNode("", true),
      (_ctx.activeSection == 'PAJAMAS')
        ? (_openBlock(), _createBlock(_component_pajamas_config, { key: 3 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}